module.exports = __WEBPACK_EXTERNAL_MODULE_127__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 127
// module chunks = 0